// Generated by CoffeeScript 2.7.0
var BUSINESS_TIME_TYPE, BusinessTimeConfig, DEFAULT_FINAL_TIME, DEFAULT_INITIAL_TIME, business_time_picker;

import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';

import DateTimePickerPopover from 'trunks/vue/admin/components/date_time_picker_popover.js';

DEFAULT_INITIAL_TIME = '09:00';

DEFAULT_FINAL_TIME = '17:00';

BUSINESS_TIME_TYPE = ['workday', 'everyday'];

business_time_picker = {
  props: {
    initValue: Date
  },
  data: function() {
    return {
      value: this.initValue || new Date()
    };
  },
  components: {
    'datetime-picker': DateTimePickerPopover
  },
  template: `<datetime-picker :initValue='value'
                 viewMode='time'
                 position='bottom center'
                 :modeChangeable='false'
                 ref='datetimepickerRef'
                 @valueChanged='valueChangeFunc'
                 @beforeOpenPopover='beforeOpenPopoverFunc'>
  <div class="input-control right-addon" slot='trigger'>
    <input type="text" placeholder='请选择' readonly :value='displayValue' />
    <div class="addon">
      <i class="slp-time-circle"></i>
    </div>
  </div>
</datetime-picker>`,
  computed: {
    displayValue: function() {
      return this.value.strftime('hh:mm');
    }
  },
  methods: {
    setValue: function(value) {
      return this.value = value;
    },
    beforeOpenPopoverFunc: function() {
      return this.$refs.datetimepickerRef.setDatetimepickerValue(this.value);
    },
    valueChangeFunc: function(value) {
      this.value = value;
      return this.$emit('valueChanged', this.value);
    },
    getDisplayValue: function() {
      return this.displayValue;
    }
  }
};

export default BusinessTimeConfig = {
  components: {
    'dropdown-select': DropdownSelect,
    'business-time-picker': business_time_picker
  },
  props: {
    customClass: String,
    initValue: {
      type: Object,
      default: function() {
        return {
          workday: true,
          initial: DEFAULT_INITIAL_TIME,
          final: DEFAULT_FINAL_TIME
        };
      }
    }
  },
  data: function() {
    return {
      type: 'workday',
      initialTime: null,
      finalTime: null
    };
  },
  template: `<div class="business-time-config" :class='customClass'>
  <dropdown-select :optionGroups="[{ options: allowedBusinessTimeType }]"
                   customClass='transparent'
                   :initValue="type"
                   @change='typeChangeFunc'>
    <template slot='value-template' slot-scope='{ option }'>
      <span>{{ Skylark.Helpers.getZH_CN('date.businessTime.' + option) }}</span>
    </template>
    <template slot='option-template' slot-scope='{ option }'>
      <span>{{ Skylark.Helpers.getZH_CN('date.businessTime.' + option) }}</span>
    </template>
  </dropdown-select>
  <business-time-picker :initValue='initialTime'
                        ref='initialTimePickerRef'
                        @valueChanged='initialTimeChangeFunc' />
  <span class="picker-divider">~</span>
  <business-time-picker :initValue='finalTime'
                        ref='finalTimePickerRef'
                        @valueChanged='finalTimeChangeFunc' />
</div>`,
  created: function() {
    this.init();
    return this.allowedBusinessTimeType = BUSINESS_TIME_TYPE;
  },
  methods: {
    init: function() {
      this.type = this.initValue.workday ? 'workday' : 'everyday';
      this.initialTime = Date.parseFromString(this.initValue.initial || DEFAULT_INITIAL_TIME);
      return this.finalTime = Date.parseFromString(this.initValue.final || DEFAULT_FINAL_TIME);
    },
    reset: function() {
      this.init();
      this.$refs.initialTimePickerRef.setValue(this.initialTime);
      return this.$refs.finalTimePickerRef.setValue(this.finalTime);
    },
    typeChangeFunc: function(type) {
      this.type = type;
      return this.emitChangeEvent();
    },
    initialTimeChangeFunc: function(time) {
      this.initialTime = time;
      return this.emitChangeEvent();
    },
    finalTimeChangeFunc: function(time) {
      this.finalTime = time;
      return this.emitChangeEvent();
    },
    emitChangeEvent: function() {
      var business_time;
      business_time = {
        workday: Boolean(this.type === 'workday'),
        initial: this.$refs.initialTimePickerRef.getDisplayValue(),
        final: this.$refs.finalTimePickerRef.getDisplayValue()
      };
      return this.$emit('valueChanged', business_time);
    }
  }
};
